// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"389":"404","401":"orderEdit","472":"settings","766":"statistics","852":"orders","864":"SellView","962":"home","983":"products"}[chunkId] + "." + {"389":"8a2907b4","401":"03651845","472":"4a12e82a","766":"9168224c","852":"2c4af444","864":"010d474a","962":"8e473d41","983":"69cd9618"}[chunkId] + ".css";
};